import { Editor, Range } from "@tiptap/core";
import { SuggestionOptions } from "@tiptap/suggestion";

import { normalizeEmptyHtml } from "@/utils/rich-text";

import { InsertableDotPhrase } from "../types/insertable-dot-phrase";
import { normalizeDotPhraseBodyHtml } from "../utils/dot-phrases";

import { startDotPhraseFields } from "./dot-phrase-fields-state";

type DotPhraseSuggestionCommand = NonNullable<SuggestionOptions<InsertableDotPhrase>["command"]>;

export function insertDotPhraseBody(
  editor: Editor,
  range: Range,
  dotPhrase: InsertableDotPhrase,
): void {
  const bodyHtml = normalizeDotPhraseBodyHtml(dotPhrase.bodyHtml);

  editor
    .chain()
    .focus()
    .insertContentAt(range, normalizeEmptyHtml(bodyHtml))
    .command(({ tr }) => {
      startDotPhraseFields(tr, range.from, tr.selection.from);

      return true;
    })
    .run();
}

export const dotPhraseInsertCommand: DotPhraseSuggestionCommand = ({ editor, range, props }) => {
  insertDotPhraseBody(editor, range, props);
};
